import React, { useEffect, useRef, useState, } from 'react';
import { Dimensions, Keyboard, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DropDownOrientation, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { Typography } from '../../typography/Typography';
import { Button } from '../../button/Button';
import { Header } from '../../header/Header';
import { isMobile } from '../../stack/utils';
import { getScreenType } from '../bankSelectPage/BankSelect';
import { DropdownInput } from '../../dropDownInput/DropDownBaseInput';
import { Icon } from '../../icon/Icon';
import { Space } from '../../space/Space';
import { LENDER_ID } from "../constants";
import NeedHelpDC from "../NeedHelpDC";
import TextInputDLS from "../../textInputDLS/textInputDLS";
import { alphabetsAndDotRegex } from "../utils";
export var EDUCATION;
(function (EDUCATION) {
    EDUCATION["DIPLOMA"] = "DIPLOMA";
    EDUCATION["POST_GRADUATE"] = "POST_GRADUATE";
    EDUCATION["UNDER_GRADUATE"] = "UNDER_GRADUATE";
    EDUCATION["UP_TO_12"] = "UP_TO_12";
    EDUCATION["MBA"] = "MBA";
    EDUCATION["PHD"] = "PHD";
    EDUCATION["PROFESSIONAL"] = "PROFESSIONAL";
    EDUCATION["OTHERS"] = "OTHERS";
})(EDUCATION || (EDUCATION = {}));
const KycAddtionalDetails = ({ stepperData, triggerAction, applyAction, height, qualification, mothersFirstName, mothersLastName, fathersLastName, fathersFirstName, backAction, lenderName, incomeRange, purposeOfLoan, showVerticalScroll, needHelpAction, loading, isFromJupiter, contactUsDetails, employmentStatus, sourceOfIncome }) => {
    const [userQualification, setQualification] = useState(qualification || "");
    const [incomeRangeValue, setIncomeRangeValue] = useState(incomeRange ? incomeRange : "");
    const [motherNameDesc, setMotherNameDesc] = useState("Enter your mother’s first name & last name");
    const [fatherNameDesc, setFatherNameDesc] = useState(lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? "Please enter father's name as per PAN" : "Enter your father’s first name & last name");
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [employmentStatusValue, setEmploymentStatus] = useState(employmentStatus ? employmentStatus : '');
    const [isDropDownClicked, setDropDownClicked] = useState(false);
    const [purposeOfLoanValue, setPurposeOfLoanValue] = useState(purposeOfLoan ? purposeOfLoan : "");
    const [sourceOfIncomeValue, setSourceOfIncomeValue] = useState(sourceOfIncome ? sourceOfIncome : "");
    const [isPurposeDropDownClicked, setPurposeDropDownClicked] = useState(false);
    let counter = 0;
    const [buttonActive, setButtonActive] = useState(false);
    const [singleChecked, setSingleCheked] = useState(true);
    const [marriedChecked, setMarriedChecked] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [rupeeLottie, setRupeeLottie] = useState('');
    const [cardState, setModalState] = useState('Penny');
    const [modalHeight, setModalHeight] = useState(332);
    const [successLottie, setSuccessLottie] = useState('');
    const [mFname, setMfName] = useState(mothersFirstName);
    const [mLname, setMlName] = useState(mothersLastName);
    const [fatherName, setFathernName] = useState(fathersFirstName);
    const [fatherLastName, setFatherLastName] = useState(fathersLastName);
    const scrollRef = useRef(null);
    const theme = ThemeProvider.getTheme();
    const fontFamilyMapping = theme.fontFamily;
    const colorMapping = theme.colors;
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null,
    };
    const data = lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? [
        { label: 'Up to 12th pass', value: EDUCATION.UP_TO_12 },
        { label: 'Graduate', value: EDUCATION.UNDER_GRADUATE },
        { label: 'Post graduate or higher', value: EDUCATION.POST_GRADUATE },
        { label: 'Others', value: EDUCATION.OTHERS },
    ] : [
        { label: 'Up to 12', value: EDUCATION.UP_TO_12 },
        { label: 'Diploma', value: EDUCATION.DIPLOMA },
        { label: 'Graduate', value: EDUCATION.UNDER_GRADUATE },
        { label: 'Post graduate', value: EDUCATION.POST_GRADUATE },
        { label: 'MBA', value: EDUCATION.MBA },
        { label: 'PHD', value: EDUCATION.PHD },
        { label: 'Professional', value: EDUCATION.PROFESSIONAL },
        { label: 'Others', value: EDUCATION.OTHERS },
    ];
    useEffect(() => {
        if (showNeedHelp)
            Keyboard.dismiss();
    }, [showNeedHelp]);
    const useOfLoanData = lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? [
        { label: 'Personal', value: 'PERSONAL' },
        { label: 'Business', value: 'BUSINESS' },
        { label: 'Investments', value: 'INVESTMENT' },
        { label: 'Emergency', value: 'EMERGENCY' },
    ] : [
        { label: 'Personal', value: 'PERSONAL' },
        { label: 'Business', value: 'BUSINESS' },
        { label: 'Education', value: 'EDUCATION' },
        { label: 'Travel', value: 'TRAVEL' },
        { label: 'Medical expenses', value: 'MEDICAL' },
        { label: 'Investment', value: 'INVESTMENT' },
        { label: 'Others', value: 'OTHERS' }
    ];
    const purposeOfLoanData = [
        { label: 'Wedding', value: 'WEDDING' },
        { label: 'Home Renovation/Decor', value: 'HOME' },
        { label: 'Medical or Hospitalisation expenses', value: 'MEDICAL' },
        { label: 'Education', value: 'EDUCATION' },
        { label: 'Holiday/Vacation', value: 'HOLIDAY' },
        { label: 'Others', value: 'OTHERS' },
    ];
    const occupationData = [
        { label: 'Student', value: 'STUDENT' },
        { label: 'Salaried', value: 'SALARIED' },
        { label: 'Self Employed', value: 'SELF_EMPLOYED' },
        { label: 'Retired', value: 'RETIRED' }
    ];
    const sourceOfIncomeData = [
        { label: 'Employment', value: 'EMPLOYMENT' },
        { label: 'Self-Employment', value: 'SELF_EMPLOYMENT' },
        { label: 'Investment', value: 'INVESTMENT' },
        { label: 'Rental', value: 'RENTAL' },
        { label: 'Retirement', value: 'RETIREMENT' },
        { label: 'Other (e.g. gifts, inheritances, royalties)', value: 'OTHERS' },
    ];
    const incomeRangeData = lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? [
        { label: 'less than 3 lakhs', value: 'ANNUAL_0_3_LAKHS' },
        { label: '3 to 10 lakhs', value: 'ANNUAL_3_10_LAKHS' },
        { label: '10 to 25 lakhs', value: 'ANNUAL_10_25_LAKHS' },
        { label: 'more than 25 lakhs', value: 'ANNUAL_MORE_THAN_25_LAKHS' },
    ] : [
        { label: '3-10 lakhs', value: 'ANNUAL_3_10_LAKHS' },
        { label: '10-25 lakhs', value: 'ANNUAL_10_25_LAKHS' },
        { label: 'More than 25 lakhs', value: 'ANNUAL_MORE_THAN_25_LAKHS' },
    ];
    const employmentStatusData = [
        { label: 'Salaried', value: 'SALARIED' },
        { label: 'Self employed', value: 'SELF_EMPLOYED' },
        { label: 'Business owner', value: 'BUSINESS_OWNER' },
        { label: 'Others', value: 'OTHERS' },
    ];
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const renderRadioButtons = () => {
        return (React.createElement(View, { style: { flexDirection: 'row' } },
            React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: () => {
                    if (marriedChecked) {
                        setSingleCheked(true);
                        setMarriedChecked(false);
                    }
                }, style: { flexDirection: 'row', alignContent: 'center', alignItems: 'center' } },
                React.createElement(View, { nativeID: 'rb_borrowerKycAdditionalDetails_single' },
                    React.createElement(Icon, { name: singleChecked
                            ? IconTokens.RadioCircleFilled
                            : IconTokens.RadioCircleNotFilled, size: IconSizeTokens.XXL })),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Typography, { label: 'Single', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '500', lineHeight: 20, color: ColorTokens.Grey_Night })),
            React.createElement(Space, { size: SizeTypeTokens.Size6 }),
            React.createElement(TouchableOpacity, { onPress: () => {
                    if (singleChecked) {
                        setMarriedChecked(true);
                        setSingleCheked(false);
                    }
                }, style: { marginLeft: 48, flexDirection: 'row', alignContent: 'center', alignItems: 'center' } },
                React.createElement(View, { nativeID: 'rb_borrowerKycAdditionalDetails_married' },
                    React.createElement(Icon, { name: marriedChecked
                            ? IconTokens.RadioCircleFilled
                            : IconTokens.RadioCircleNotFilled, size: IconSizeTokens.XXL })),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Typography, { label: 'Married', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '500', lineHeight: 20 }))));
    };
    useEffect(() => {
        if ((lenderName.toLowerCase() === LENDER_ID.NUVAMA.toLowerCase()) &&
            (mFname == ""
                || mLname == ""
                || fatherLastName == ""
                || fatherName == ""
                || userQualification == ""
                || incomeRangeValue == ""
                || purposeOfLoanValue == "")) {
            setButtonActive(false);
        }
        else if (lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase() &&
            (mFname === ""
                || mLname === ""
                || fatherLastName === ""
                || fatherName === ""
                || userQualification === ""
                || incomeRangeValue === ""
                || purposeOfLoanValue === ""
                || employmentStatusValue === "")) {
            setButtonActive(false);
        }
        else if (lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() &&
            (fatherLastName === ""
                || fatherName === ""
                || incomeRangeValue === ""
                || purposeOfLoanValue === ""
                || employmentStatusValue === ""
                || sourceOfIncomeValue === ""
                || userQualification === "")) {
            setButtonActive(false);
        }
        else if (lenderName.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase() && (fatherLastName === ""
            || fatherName === ""
            || userQualification === ""
            || mFname === ""
            || mLname === "")) {
            setButtonActive(false);
        }
        else {
            setButtonActive(true);
        }
    }, [mFname, mLname, fatherLastName, fatherName, userQualification, incomeRangeValue, employmentStatusValue, purposeOfLoanValue, sourceOfIncomeValue]);
    useEffect(() => {
        fetch('https://lottie.host/dc3da369-5394-4cb5-9987-3a8856083e44/vsSFRAuwxF.json', {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setRupeeLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        fetch('https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json', {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setSuccessLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        return () => {
            setModalHeight(332);
            setModalState('Penny');
            setShowModal(false);
        };
    }, []);
    useEffect(() => {
        if (isDropDownClicked && !isPurposeDropDownClicked) {
            scrollRef.current.scrollToEnd({ animated: true });
        }
    }, [isDropDownClicked, counter, isPurposeDropDownClicked]);
    const [tempHeight, setTempHeight] = useState(height);
    useEffect(() => {
        const handleKeyboardDidShow = (event) => {
            const extraSpace = -50;
            const keyboardHeight = event.endCoordinates.height || 0;
            const newViewHeight = height - keyboardHeight - extraSpace;
            // scrollRef?.current?.scrollToEnd()
            setTempHeight(newViewHeight);
        };
        const handleKeyboardDidHide = () => {
            setTempHeight(height);
        };
        const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', handleKeyboardDidShow);
        const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', handleKeyboardDidHide);
        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);
    // @ts-ignore
    return (React.createElement(View, { style: [styles.container, { height: height }] },
        React.createElement(View, { style: styles.header },
            React.createElement(Header, { id: "bt_borrowerKycAdditionalDetails_goBack", type: HeaderTypeTokens.verification, needHelpIcon: true, needHelpAction: () => handleNeedHelp(), stepperProps: stepperProps, isBackButton: true, title: 'KYC verification', onPress: () => {
                    if (backAction) {
                        triggerAction(backAction);
                    }
                }, isFromJupiter: isFromJupiter })),
        React.createElement(View, { style: {
                height: Platform.OS === 'ios' ? tempHeight - 180 : height - 189,
            } },
            React.createElement(ScrollView, { ref: scrollRef, style: [styles.scrollView, {
                        ...Platform.OS !== 'ios' && { height: height - 100 },
                        ...Platform.OS === 'ios' && { flex: 1 }
                    }], nestedScrollEnabled: true, showsVerticalScrollIndicator: showVerticalScroll },
                React.createElement(TouchableOpacity, { style: { margin: 16, marginTop: 24 }, activeOpacity: 1 },
                    React.createElement(Typography, { label: 'Additional information', fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, fontWeight: '700', lineHeight: 24 }),
                    React.createElement(View, { style: { marginTop: 16 } },
                        React.createElement(Typography, { label: 'Marital status', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
                    React.createElement(View, { style: { marginTop: 12 } }, renderRadioButtons()),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(Typography, { label: lenderName === "Mirae" ? 'Select occupation' : 'Qualification', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
                    React.createElement(View, { style: { marginTop: 16 }, nativeID: 'tf_borrowerKycAdditionalDetails_qualification' },
                        React.createElement(DropdownInput, { label: lenderName === "Mirae" ? 'Select occupation' : 'Select qualification', 
                            // @ts-ignore
                            data: data, height: 180, value: qualification, onValueSelect: (value) => {
                                if (value !== "")
                                    setQualification(value);
                            } })),
                    lenderName.toLowerCase() !== LENDER_ID.TATA.toLowerCase() &&
                        React.createElement(React.Fragment, null,
                            React.createElement(View, { style: { marginTop: 20 } },
                                React.createElement(Typography, { label: "Mother’s name", fontSize: FontSizeTokens.SM, lineHeight: 20, fontFamily: FontFamilyTokens.Inter, fontWeight: "600" })),
                            React.createElement(View, { style: {
                                    flexDirection: 'row',
                                    marginTop: 8,
                                    width: '100%',
                                } },
                                React.createElement(View, { style: { flex: 0.5 } },
                                    React.createElement(TextInputDLS, { nativeID: 'tf_borrowerKycAdditionalDetails_motherFirstName', label: "Mother's first name", holder: "First name", value: mFname, autoFocus: false, onChangeText: (text) => {
                                            if (alphabetsAndDotRegex.test(text)) {
                                                setMfName(text);
                                            }
                                        } })),
                                React.createElement(View, { style: { flex: 0.5, marginLeft: 12 } },
                                    React.createElement(TextInputDLS, { nativeID: 'tf_borrowerKycAdditionalDetails_motherLastName', label: "Mother's last name", holder: "Last name", value: mLname, autoFocus: false, onChangeText: (text) => {
                                            if (alphabetsAndDotRegex.test(text)) {
                                                setMlName(text);
                                            }
                                        } }))),
                            React.createElement(View, { style: { flexDirection: 'row', marginTop: 4 } },
                                React.createElement(Icon, { name: (mLname && mFname) ? "" : IconTokens.Info, color: ColorTokens.System_Warning }),
                                React.createElement(Space, { size: SizeTypeTokens.MD }),
                                React.createElement(Typography, { label: (mLname && mFname) ? "" : motherNameDesc, color: ColorTokens.System_Warning, fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 18 }))),
                    React.createElement(View, { style: { marginTop: 20 } },
                        React.createElement(Typography, { label: "Father’s name", fontSize: FontSizeTokens.SM, lineHeight: 20, fontFamily: FontFamilyTokens.Inter, fontWeight: "600" })),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginTop: 8,
                        } },
                        React.createElement(View, { style: { flex: 0.5 } },
                            React.createElement(TextInputDLS, { nativeID: 'tf_borrowerKycAdditionalDetails_fatherFirstName', label: "Father's first name", holder: "First name", value: fatherName, autoFocus: false, onChangeText: (text) => {
                                    if (alphabetsAndDotRegex.test(text)) {
                                        setFathernName(text);
                                    }
                                } })),
                        React.createElement(View, { style: { flex: 0.5, marginLeft: 12 } },
                            React.createElement(TextInputDLS, { nativeID: 'tf_borrowerKycAdditionalDetails_fatherLastName', label: "Father's last name", holder: "Last name", value: fatherLastName, autoFocus: false, onChangeText: (text) => {
                                    if (alphabetsAndDotRegex.test(text)) {
                                        setFatherLastName(text);
                                    }
                                } }))),
                    lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() && (!fatherName || !fatherLastName) &&
                        React.createElement(View, { style: { flexDirection: 'row', marginTop: 8 } },
                            React.createElement(Icon, { name: (fatherName && fatherLastName) ? "" : IconTokens.Info, color: ColorTokens.System_Error }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            React.createElement(Typography, { label: (fatherName && fatherLastName) ? "" : fatherNameDesc, color: lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? ColorTokens.System_Error : ColorTokens.System_Warning, fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 18 })),
                    lenderName.toLowerCase() !== LENDER_ID.TATA.toLowerCase() &&
                        React.createElement(View, { style: { flexDirection: 'row', marginTop: 8 } },
                            React.createElement(Icon, { name: (fatherName && fatherLastName) ? "" : IconTokens.Info, color: ColorTokens.System_Warning }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            React.createElement(Typography, { label: (fatherName && fatherLastName) ? "" : fatherNameDesc, color: ColorTokens.System_Warning, fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 18 })),
                    (lenderName.toLowerCase() === LENDER_ID.NUVAMA.toLowerCase()
                        || lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase()) &&
                        React.createElement(React.Fragment, null,
                            React.createElement(View, { style: { marginTop: 20 } },
                                React.createElement(Typography, { label: 'Purpose of loan', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
                            React.createElement(View, { style: { marginTop: 16 } },
                                React.createElement(DropdownInput, { label: purposeOfLoanValue ? purposeOfLoanValue : 'Purpose of loan', 
                                    // @ts-ignore
                                    data: useOfLoanData, height: 180, value: purposeOfLoanValue, dropDownOrientation: DropDownOrientation.BOTTOM, onValueSelect: (value) => {
                                        if (value !== "")
                                            setPurposeOfLoanValue(value);
                                    }, onOpenDropDown: () => {
                                        setPurposeDropDownClicked(true);
                                        setDropDownClicked(true);
                                        scrollRef?.current?.scrollToEnd({ animated: true });
                                        counter++;
                                    }, isDropDownClicked: isDropDownClicked }))),
                    (lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase()) &&
                        React.createElement(React.Fragment, null,
                            React.createElement(View, { style: { marginTop: 20 } },
                                React.createElement(Typography, { label: 'Purpose of loan', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
                            React.createElement(View, { style: { marginTop: 16 } },
                                React.createElement(DropdownInput, { label: purposeOfLoanValue ? purposeOfLoanValue : 'Select purpose', 
                                    // @ts-ignore
                                    data: purposeOfLoanData, height: 180, value: purposeOfLoanValue, dropDownOrientation: DropDownOrientation.BOTTOM, onValueSelect: (value) => {
                                        if (value !== "")
                                            setPurposeOfLoanValue(value);
                                    }, onOpenDropDown: () => {
                                        setPurposeDropDownClicked(true);
                                        setDropDownClicked(true);
                                        scrollRef?.current?.scrollTo({
                                            x: 0,
                                            y: 200,
                                            animated: true,
                                        });
                                        counter++;
                                    }, isDropDownClicked: isDropDownClicked }))),
                    lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() && React.createElement(React.Fragment, null,
                        React.createElement(View, { style: { marginTop: 20 } },
                            React.createElement(Typography, { label: 'Occupation', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
                        React.createElement(View, { style: { marginTop: 16 } },
                            React.createElement(DropdownInput, { label: employmentStatusValue ? employmentStatusValue : 'Select occupation', 
                                // @ts-ignore
                                data: occupationData, height: 180, value: employmentStatusValue, dropDownOrientation: DropDownOrientation.BOTTOM, onValueSelect: (value) => {
                                    if (value !== "")
                                        setEmploymentStatus(value);
                                }, onOpenDropDown: () => {
                                    setDropDownClicked(true);
                                    scrollRef?.current?.scrollToEnd({ animated: true });
                                    counter++;
                                }, isDropDownClicked: isDropDownClicked }))),
                    lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() && React.createElement(React.Fragment, null,
                        React.createElement(View, { style: { marginTop: 20 } },
                            React.createElement(Typography, { label: 'Source of income', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
                        React.createElement(View, { style: { marginTop: 16 } },
                            React.createElement(DropdownInput, { label: sourceOfIncomeValue ? sourceOfIncomeValue : 'Select source of income', 
                                // @ts-ignore
                                data: sourceOfIncomeData, height: 180, value: sourceOfIncomeValue, dropDownOrientation: DropDownOrientation.BOTTOM, onValueSelect: (value) => {
                                    if (value !== "")
                                        setSourceOfIncomeValue(value);
                                }, onOpenDropDown: () => {
                                    setDropDownClicked(true);
                                    scrollRef?.current?.scrollToEnd({ animated: true });
                                    counter++;
                                }, isDropDownClicked: isDropDownClicked }))),
                    (lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase()
                        || lenderName.toLowerCase() === LENDER_ID.NUVAMA.toLowerCase()
                        || lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase()) &&
                        React.createElement(React.Fragment, null,
                            React.createElement(View, { style: { marginTop: 20 } },
                                React.createElement(Typography, { label: 'Income range', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
                            React.createElement(View, { style: { marginTop: 16 } },
                                React.createElement(DropdownInput, { label: incomeRangeValue ? incomeRangeValue : lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? 'Select source of income' : 'Income range', 
                                    // @ts-ignore
                                    data: incomeRangeData, height: lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? 180 : lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? 130 : 190, dropDownOrientation: DropDownOrientation.BOTTOM, value: incomeRangeValue, onValueSelect: (value) => {
                                        if (value !== "")
                                            setIncomeRangeValue(value);
                                    }, onOpenDropDown: () => {
                                        setDropDownClicked(true);
                                        scrollRef?.current?.scrollToEnd({ animated: true });
                                        counter++;
                                    }, isDropDownClicked: isDropDownClicked }))),
                    (lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase()) &&
                        React.createElement(React.Fragment, null,
                            React.createElement(View, { style: { marginTop: 20 } },
                                React.createElement(Typography, { label: 'Employment status', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600' })),
                            React.createElement(View, { style: { marginTop: 16 } },
                                React.createElement(DropdownInput, { label: employmentStatusValue ? employmentStatusValue : 'Employment status', 
                                    // @ts-ignore
                                    data: employmentStatusData, height: 180, dropDownOrientation: DropDownOrientation.BOTTOM, value: employmentStatusValue, onValueSelect: (value) => {
                                        if (value !== "")
                                            setEmploymentStatus(value);
                                    }, onOpenDropDown: () => {
                                        setDropDownClicked(true);
                                        scrollRef?.current?.scrollToEnd({ animated: true });
                                        counter++;
                                    }, isDropDownClicked: isDropDownClicked })))),
                React.createElement(Space, { size: SizeTypeTokens.XXXXXL }),
                React.createElement(Space, { size: SizeTypeTokens.XXXXXL }),
                React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                (Platform.OS !== 'web') && (React.createElement(React.Fragment, null,
                    React.createElement(Space, { size: SizeTypeTokens.XXXXXL }),
                    React.createElement(Space, { size: SizeTypeTokens.XXXXXL }),
                    React.createElement(Space, { size: SizeTypeTokens.XXXL }))))),
        React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                width: '100%',
                justifyContent: 'center',
                borderColor: '#F1F3F5',
                borderTopWidth: 1,
                paddingHorizontal: -16,
                paddingVertical: 8,
                backgroundColor: 'white',
            } },
            React.createElement(View, { style: {
                    alignContent: 'center',
                    alignItems: 'center',
                    marginTop: 8,
                    flexDirection: 'row',
                    justifyContent: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.Secure, size: IconSizeTokens.XS, color: ColorTokens.Secondary_100 }),
                React.createElement(Space, { size: SizeTypeTokens.XS }),
                React.createElement(Typography, { label: 'Your data is secure with us', fontSize: FontSizeTokens.XXS, fontWeight: '500', lineHeight: 16, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter })),
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    marginTop: 8,
                    marginBottom: 6,
                    paddingBottom: Platform.OS === "ios" ? 10 : 0
                } },
                React.createElement(Button, { loading: loading, id: 'bt_borrowerKycAdditionalDetails_continue', type: buttonActive
                        ? ButtonTypeTokens.LargeFilled
                        : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue', onPress: () => {
                        if (applyAction) {
                            const kycObj = {
                                maritalStatus: singleChecked ? "SINGLE" : "MARRIED",
                                qualification: userQualification,
                                fatherFirstName: fatherName.trim(),
                                fatherLastName: fatherLastName.trim(),
                                motherFirstName: lenderName.toLowerCase() !== LENDER_ID.TATA.toLowerCase() && mFname.trim(),
                                motherLastName: lenderName.toLowerCase() !== LENDER_ID.TATA.toLowerCase() && mLname.trim(),
                                ...(lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase()
                                    || lenderName.toLowerCase() === LENDER_ID.NUVAMA.toLowerCase()
                                    || lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase()) && { incomeRangeValue: incomeRangeValue },
                                ...(lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase()) &&
                                    { employmentStatus: employmentStatusValue },
                                ...(lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase() || lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase()) && { purposeOfLoan: purposeOfLoanValue },
                                ...(lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase()) && { sourceOfIncome: sourceOfIncomeValue },
                                ...(lenderName.toLowerCase() === LENDER_ID.TATA.toLowerCase()) &&
                                    { employmentStatus: employmentStatusValue },
                            };
                            triggerAction({
                                ...applyAction,
                                payload: {
                                    selectedItem: kycObj,
                                },
                            });
                        }
                    } }))),
        showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })));
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height,
        marginHorizontal: -16,
    },
    header: {
        ...Platform.OS === "ios" && {
            marginTop: 24
        }
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    dropdown: {
        margin: 16,
        height: 50,
        width: 150,
        backgroundColor: '#EEEEEE',
        borderRadius: 22,
        paddingHorizontal: 8,
    },
    scrollView: {
        ...Platform.OS !== 'web' && {
            paddingBottom: 20
        }
    }
});
export default KycAddtionalDetails;
